import { groq } from '@sanity-codegen/client';

export const contactPersonQuery = groq`
"contactPerson": {
  ...contactPersonObject.contactPerson->,
  "headerTitle": contactPersonObject.contactPersonTitle,
}
`;
